import type { ILawyerDetail } from '@/entities/lawyer/model/types/lawyer';
import type { ICalendarViewer } from '@/pages/lawyer/model/types/useLawyerDetail';

export const isCalendarVisible = (info: ILawyerDetail | null): boolean => {
  if (!info) return false;
  const isEnabled = Boolean(info.is_appointment_region || info.is_appointment_online);
  const hasBalance = Boolean(info.is_region_balance || info.is_online_balance);
  return isEnabled && hasBalance;
};

export const isCalendarVisibleForViewer = (
  info: ILawyerDetail | null,
  viewer: ICalendarViewer,
): boolean => (viewer.isRoleTypeUser || !viewer.isAuth) && isCalendarVisible(info);
